import Rating from '@mui/material/Rating';
import { IFieldProps } from '../fields/InputField';
import { useEffect, useState } from 'react';
import { Typography } from '@mui/material';

const RatingField = ({ field, onChange, isReadOnly }: IFieldProps) => {
    const [rating, setRating] = useState<number | null>(null);

    useEffect(() => {
        if (!field.values.length) return;
        const fieldRating = Number(field.values[0].value);
        if (isNaN(fieldRating)) return;

        setRating(fieldRating);
    }, [])

    useEffect(() => {
        if (isReadOnly) return;
        if (!rating) return onChange && onChange([]);

        onChange && onChange([{ id: 0, value: rating.toString() }])
    }, [rating])

    return <Rating
        name="simple-controlled"
        value={rating}
        disabled={isReadOnly}
        onChange={(event, newValue) => {
            setRating(newValue);
        }}
    />
}

export default RatingField;